import React from 'react';
import { BeatLoader } from 'react-spinners';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

import { ModalContainer } from 'components/guardedModal/ModalContainer';
import { SimpleModalId } from 'constants/modalId';
import AppModal from 'components/modal/appModal';
import styles from './MoParticipantsSyncModal.module.scss';

export const SYNC_START = 'SYNC_START';
export const SYNC_SUCCESS = 'SYNC_SUCCESS';
export const SYNC_FAILURE = 'SYNC_FAILURE';
export const REFRESH_LIST_REQUEST = 'REFRESH_LIST_REQUEST';
export const REFRESH_LIST_SUCCESS = 'REFRESH_LIST_SUCCESS';

type Value =
  | typeof SYNC_START
  | typeof SYNC_SUCCESS
  | typeof SYNC_FAILURE
  | typeof REFRESH_LIST_REQUEST
  | typeof REFRESH_LIST_SUCCESS;

const getStatus = (value: Value) => {
  switch (value) {
    case SYNC_START:
      return (
        <>
          <BeatLoader />
          <div>Syncing, waiting for response</div>
        </>
      );
    case SYNC_SUCCESS:
      return (
        <div>
          <BeatLoader />
          <div>Synchronization ended with success</div>
          <div>Refreshing participants list</div>
        </div>
      );
    case SYNC_FAILURE:
      return (
        <div>
          <div>
            <FontAwesomeIcon icon={faExclamationCircle} />
          </div>
          Synchronization ended with failure
        </div>
      );
    case REFRESH_LIST_SUCCESS:
      return <div>Participant list updated successfully</div>;
    default:
      return <BeatLoader />;
  }
};

const Content = ({ id, status }: any) => {
  return (
    <AppModal title="MO participants synchronization" id={id} hideOpenButton closeButtonLabel="Close">
      <div className={styles.wrapper}>{getStatus(status)}</div>
    </AppModal>
  );
};

export const MoParticipantsSyncModal = () => {
  return (
    <ModalContainer id={SimpleModalId.MoParticipantsSync}>
      <Content />
    </ModalContainer>
  );
};
